import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { Form, FormInput} from 'react-form';
import async from 'async';

import KPIsChart from 'routes/app/components/Dashboard/AquisitionChart';
import KPIsChartUptime from 'routes/app/components/Dashboard/KPIsChartUptime';
import AquisitionChart from 'routes/app/components/Dashboard/KPIsChart';
import ToneChart from 'routes/app/components/Dashboard/ToneKPIsChart';
import DynamicChart from 'routes/app/components/Dashboard/DynamicKPIsChart';


import ReactEcharts from 'routes/app/components/Dashboard/ReactEChart';
import ReactEchartUptime from 'routes/app/components/Dashboard/ReactEChartUptime';
import StatBoxes from 'routes/app/components/Dashboard/StatBoxes';
import { toggleLoading } from 'stores/actions';
import ReportService from 'services/ReportService';
import Translate from 'translate';
import _ from "lodash";
import { FormGroup, InputDate, Select } from 'components/FormElements';
import { required, validFixedLine, email, validPhoneLEC, equalTo, greaterThan, dateGreaterThanNowYear } from 'constants/InputErrors';


class Dashboard extends React.Component {
  constructor( props ) {
    super( props );
    this.date = new Date();
    this.firstDay = new Date(this.date.getFullYear(), this.date.getMonth(), 1);
    this.state = {
      data: {},
      dateTo: this.date ,
      currentDate: this.date,
      dateFrom: this.firstDay,
      daysAgo: Math.ceil( ( this.date - this.firstDay ) / ( 3600 * 24 * 1000 ) ),
    };
  }

  componentDidMount() {
    this.getData()
  }

  getData() {
    const {dateFrom, dateTo, currentDate} = this.state;
    this.props.toggleLoading( true );
    const daysAgo = Math.ceil( ( dateTo - dateFrom ) / ( 3600 * 24 * 1000 ) );
    const params = {dateFrom: moment(dateFrom).format('YYYY-MM-DD') , dateTo: moment(dateTo).format('YYYY-MM-DD') };
    const paramsUptime = {from: moment(dateFrom).format('YYYY-MM-DD') , to: moment(dateTo).format('YYYY-MM-DD') };
    const isCurrentDate = moment(currentDate).format('YYYY-MM-DD')  === moment(dateTo).format('YYYY-MM-DD')  ? true : false;
    
    
    async.parallel({
      data1: ( cb ) => {
        ReportService.getReportsUptime( paramsUptime ).then( ( response ) => {
          if( response.errors ) return cb( null, { } );
          return cb( null, response.data  );
        } );
      },
      data4: (cb) => {
        ReportService.getDashboardReports1( params ).then( response => {
          if( response.errors ) return cb( null, { } );
          return cb( null, response.data  );
          //if( !response.errors ) {
          //  this.setState( { data: response.data, daysAgo, isCurrentDate } )
          //}
        } )
      },
      data2: (cb) => {
        ReportService.getDashboardReports2( params ).then( response => {
          if( response.errors ) return cb( null, { } );
          return cb( null, response.data  );
          //if( !response.errors ) {
          //  this.setState( { data: response.data, daysAgo, isCurrentDate } )
          //}
        } )
      },
      data3: (cb) => {
        ReportService.getReportsUptimeIncidents( paramsUptime ).then( response => {
          if( response.errors ) return cb( null, { } );
          return cb( null, response.data  );
          //if( !response.errors ) {
          //  this.setState( { data: response.data, daysAgo, isCurrentDate } )
          //}
        } )
      },
      }, (err, results) => {
          this.props.toggleLoading( false );
          if( err ) return this.props.toggleAlertError( 'Invalid username or password' );

          if( !err ) {
            const data = { uptimeData: results.data1, uptimeIncident: results.data3, ...results.data2, ...results.data4};
            this.setState( {data, daysAgo, isCurrentDate} )
          }
      });
    

  }
  handleDateChangeDateFrom = e => {
    const { dateTo } = this.state;
    this.setState({ dateFrom: e });
  };

  handleDateChangeDateTo = e => {
    const { dateFrom } = this.state;
    this.setState({ dateTo: e });
  };
  submitForm = data => {
    this.getData();
  };
  render() {
    const { data, dateFrom, dateTo, isCurrentDate } = this.state;
    const { chatActive, phoneActive, whatsappActive } = this.props;

    return (
      <div className="container-fluid no-breadcrumbs page-dashboard">
        <div className="row">
          <div className="col-md-12 mb-3">
          <Form onSubmit={this.submitForm}
            defaultValues={{ 
              dateTo: dateTo,
              dateFrom: dateFrom,
            }}
            validate={( values ) =>  { 
              return { 
                dateTo: required( values.dateTo ) ? required( values.dateTo )  : greaterThan(values.dateTo, values.dateFrom, 'date From '),
              }
            }}
            >
            {({ submitForm }) => (
              <form onSubmit={submitForm} >
                <div className="row">
                
                <div className="col-md-7" />
                <div className="col-md-2">
                <FormGroup>
                  <FormInput field="dateFrom">
                    {( { setValue, getValue, setTouched, handleDate = this.handleDateChangeDateFrom } ) =>
                    <InputDate
                      label={<Translate id="report.dateFrom" />}
                      value={dateFrom}
                      onChange={(value) => { setValue(value); handleDate(value)}}
                    />
                    }
                  </FormInput>
                </FormGroup>
                </div>
                <div className="col-md-2">
                <FormGroup>
                  <FormInput field="dateTo">
                    {( { setValue, getValue, setTouched, handleDate = this.handleDateChangeDateTo } ) =>
                    <InputDate
                      name='dateTo'
                      label={<Translate id="report.dateTo" />}
                      value={dateTo}
                      onChange={(value) => { setValue(value); handleDate(value)}}
                    />
                  }
                  </FormInput>
                </FormGroup>
                </div>

                <div className="col-md-1 text-right">
                  <button
                    style={{ marginTop: '15px', marginLeft: '-50px' }}
                    type="submit"
                    className="btn btn-info"
                  >
                    <i className="fa fa-search pointer" />
                  </button>
                </div>
              </div>
              </form>
            )}
          </Form>

          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="row">
              <div className="col-md-12">
                <StatBoxes data={data['PENDING']} chatActive={chatActive} phoneActive={phoneActive} whatsappActive={whatsappActive} title="Pending" />
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <StatBoxes data={data['RECEIVED']} chatActive={chatActive} phoneActive={phoneActive} whatsappActive={whatsappActive} title="totalIncoming" />
              </div>
            </div>

            <div className="row">
              <div className="col-md-6">
                <div className="box box-default m-0">
                  <div className="box-body">
                    <h5 className="m-0 font-weight-normal panel-title">
                      {isCurrentDate 
                       ? <Translate id="ClosedLast30days" values={{daysAgo: this.state.daysAgo}}/>
                       : <Translate id="ClosedBetween" values={{dateFrom: moment(dateFrom).format('YYYY-MM-DD') , dateTo: moment(dateTo).format('YYYY-MM-DD') }}/>
                      }
                    </h5>
                    <KPIsChart data={data['CLOSED']} chatActive={chatActive} phoneActive={phoneActive} whatsappActive={whatsappActive}/>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="box box-default m-0 full-height">
                  <div className="box-body">
                    <h5 className="m-0 font-weight-normal panel-title">
                      {isCurrentDate 
                       ? <Translate id="ActivityLast30days" values={{daysAgo: this.state.daysAgo}}/>
                       : <Translate id="ActivityBetween" values={{dateFrom: moment(dateFrom).format('YYYY-MM-DD') , dateTo: moment(dateTo).format('YYYY-MM-DD') }}/>
                      }
                    </h5>
                    <AquisitionChart data={data['ACTIVITY']} chatActive={chatActive} phoneActive={phoneActive}  whatsappActive={whatsappActive}/>
                  </div>
                </div>
              </div>
            </div>
            <div className="row mt-4">
              <div className="col-md-12">
                <div className="box box-default m-0">
                  <div className="box-body">
                    <h5 className="m-0 font-weight-normal panel-title">
                      {isCurrentDate 
                       ? <Translate id="CreatedLast30days" values={{daysAgo: this.state.daysAgo}}/>
                       : <Translate id="CreatedBetween" values={{dateFrom: moment(dateFrom).format('YYYY-MM-DD') , dateTo: moment(dateTo).format('YYYY-MM-DD') }}/>
                      }
                    </h5>
                    <ReactEcharts data={data['CREATED']} showLoading={false} chatActive={chatActive} phoneActive={phoneActive} whatsappActive={whatsappActive}/>
                  </div>
                </div>
              </div>
            </div>
            <div className="row mt-4">
              <div className="col-md-12">
                <div className="box box-default m-0">
                  <div className="box-body">
                    <h5 className="m-0 font-weight-normal panel-title">
                      {isCurrentDate 
                       ? <Translate id="ClosedLast30days" values={{daysAgo: this.state.daysAgo}}/>
                       : <Translate id="ClosedBetween" values={{dateFrom: moment(dateFrom).format('YYYY-MM-DD') , dateTo: moment(dateTo).format('YYYY-MM-DD') }}/>
                      }                    </h5>
                    <ReactEcharts data={data['CLOSED_PER_DAY']} showLoading={false} chatActive={chatActive} phoneActive={phoneActive} whatsappActive={whatsappActive}/>
                  </div>
                </div>
              </div>
            </div>
            <div className="row mt-4">
              <div className="col-md-6">
                <div className="box box-default m-0">
                  <div className="box-body">
                    <h5 className="m-0 font-weight-normal panel-title">
                      {isCurrentDate 
                       ? <Translate id="titleTonesDashboard" values={{daysAgo: this.state.daysAgo}}/>
                       : <Translate id="titleTonesDashboardBetween" values={{dateFrom: moment(dateFrom).format('YYYY-MM-DD') , dateTo: moment(dateTo).format('YYYY-MM-DD') }}/>
                      }   
                    </h5>
                    <ToneChart data={data['TONES']} chatActive={chatActive} phoneActive={phoneActive} whatsappActive={whatsappActive}/>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="box box-default m-0">
                  <div className="box-body">
                    <h5 className="m-0 font-weight-normal panel-title">
                      {isCurrentDate 
                       ? <Translate id="titleCategoriesDashboard" values={{daysAgo: this.state.daysAgo}}/>
                       : <Translate id="titleCategoriesDashboardBetween" values={{dateFrom: moment(dateFrom).format('YYYY-MM-DD') , dateTo: moment(dateTo).format('YYYY-MM-DD') }}/>
                      } 
                    </h5>
                    <DynamicChart data={this.state.data['CATEGORIES']} redraw={true} variableName={'CATEGORY'} chatActive={chatActive} phoneActive={phoneActive} whatsappActive={whatsappActive}/>
                  </div>
                </div>
              </div>
            </div>

            <div className="row mt-4">
              <div className="col-md-12">
                <div className="box box-default m-0">
                  <div className="box-body">
                    <h5 className="m-0 font-weight-normal panel-title">
                      {isCurrentDate 
                       ? <Translate id="titleServicesDashboard" values={{daysAgo: this.state.daysAgo}}/>
                       : <Translate id="titleServicesDashboardBetween" values={{dateFrom: moment(dateFrom).format('YYYY-MM-DD') , dateTo: moment(dateTo).format('YYYY-MM-DD') }}/>
                      } 
                    </h5>
                    <DynamicChart data={data['SERVICES']} variableName={'SERVICE'} chatActive={chatActive} phoneActive={phoneActive}  whatsappActive={whatsappActive}/>
                  </div>
                </div>
              </div>
        
            </div>

            <div className="row mt-4">
              <div className="col-md-12">
                <StatBoxes data={data['IMPORTANT']} chatActive={chatActive} phoneActive={phoneActive} whatsappActive={whatsappActive} title="titleByImportance" />
              </div>
            </div>
            <div className="row mt-4">
              <div className="col-md-6">
                <div className="box box-default m-0">
                  <div className="box-body">
                    <h5 className="m-0 font-weight-normal panel-title">
                      {isCurrentDate 
                       ? <Translate id="UptimeLast30daysHours" values={{daysAgo: this.state.daysAgo}}/>
                       : <Translate id="UptimeBetweenHours" values={{dateFrom: moment(dateFrom).format('YYYY-MM-DD') , dateTo: moment(dateTo).format('YYYY-MM-DD') }}/>
                      }                    </h5>
                    <KPIsChartUptime data={data['uptimeIncident']} chatActive={chatActive} phoneActive={phoneActive}  whatsappActive={whatsappActive} kpi='availableTime' days={this.state.daysAgo}/>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="box box-default m-0 full-height">
                  <div className="box-body">
                    <h5 className="m-0 font-weight-normal panel-title">
                      {isCurrentDate 
                       ? <Translate id="UptimeIncidentLast30Days" values={{daysAgo: this.state.daysAgo}}/>
                       : <Translate id="UptimeIncidentBetween" values={{dateFrom: moment(dateFrom).format('YYYY-MM-DD') , dateTo: moment(dateTo).format('YYYY-MM-DD') }}/>
                      }
                    </h5>
                    <KPIsChartUptime data={data['uptimeIncident']} chatActive={chatActive} phoneActive={phoneActive}  whatsappActive={whatsappActive} kpi='incidents' />
                  </div>
                </div>
              </div>
            </div>

            <div className="row mt-4">
              <div className="col-md-12">
                <div className="box box-default m-0">
                  <div className="box-body">
                    <h5 className="m-0 font-weight-normal panel-title">
                      {isCurrentDate 
                       ? <Translate id="UptimeLast30days" values={{daysAgo: this.state.daysAgo}}/>
                       : <Translate id="UptimeBetween" values={{dateFrom: moment(dateFrom).format('YYYY-MM-DD') , dateTo: moment(dateTo).format('YYYY-MM-DD') }}/>
                      }                    </h5>
                    <ReactEchartUptime data={data['uptimeData']} showLoading={false} chatActive={chatActive} phoneActive={phoneActive} whatsappActive={whatsappActive}/>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = ( state ) => ( {
  chatActive: state.settings.chatActive,
  phoneActive: state.settings.phoneActive,
  whatsappActive: state.settings.whatsappActive,
} );

const mapDispatchToProps = dispatch => ( {
  toggleLoading: ( isLoading ) => {
    dispatch( toggleLoading( isLoading ) );
  },
} );

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps
)( Dashboard );




// WEBPACK FOOTER //
// ./routes/app/routes/dashboard/index.js